export const createSchemaPlans = (values) => {
  return {
    name: values.name,
    desc: values?.desc || '',
    value: values.value,
    typeExpired: values?.typeExpired || '',
    payment: values?.payment || '',
    admission: values?.admission || 0,
    typePlan: values.typePlan,
    trialDays: values?.trialDays || 0,
    daysExpired: values?.daysExpired || '',
    codCupom: values?.codCupom || '',
    limitAplly: values?.limitAplly || 0,
    apllieds: values?.apllieds || 0,
    typeValue: values?.typeValue || 'amount',
    ...(values?.nAliqISS && { nAliqISS: values?.nAliqISS ? Number(values.nAliqISS) : 0 }),
    ...(values?.nAliqPIS && { nAliqPIS: values?.nAliqPIS ? Number(values.nAliqPIS) : 0 }),
    ...(values?.nAliqCOFINS && { nAliqCOFINS: values?.nAliqCOFINS ? Number(values.nAliqCOFINS) : 0 }),
    ...(values?.nAliqIR && { nAliqIR: values?.nAliqIR ? Number(values.nAliqIR) : 0 }),
    ...(values?.nAliqINSS && { nAliqINSS: values?.nAliqINSS ? Number(values.nAliqINSS) : 0 }),
    ...(values?.nRedBaseINSS && { nRedBaseINSS: values?.nRedBaseINSS ? Number(values.nRedBaseINSS) : 0 }),
    ...(values?.nRedBasePIS && { nRedBasePIS: values?.nRedBasePIS ? Number(values.nRedBasePIS) : 0 }),
    ...(values?.nRedBaseCOFINS && { nRedBaseCOFINS: values?.nRedBaseCOFINS ? Number(values.nRedBaseCOFINS) : 0 }),
    ...(values?.cRetISS && { cRetISS: values?.cRetISS }),
    ...(values?.cRetPIS && { cRetPIS: values?.cRetPIS }),
    ...(values?.cRetCOFINS && { cRetCOFINS: values?.cRetCOFINS }),
    ...(values?.cRetCSLL && { cRetCSLL: values?.cRetCSLL }),
    ...(values?.cRetIR && { cRetIR: values?.cRetIR }),
    ...(values?.cRetINSS && { cRetINSS: values?.cRetINSS }),
    ...(values?.lDeduzISS && { lDeduzISS: !!values?.lDeduzISS }),
  }
}

export const CreateSchemaCouponPagBank = (values) => {
  const expired = Number(values?.daysExpired || '0')

  const occurrences = expired / 30

  const amountValue = values?.typeValue === 'percent' ? Number(values.value) : Math.round(values.value * 100)

  return {
    discount: {
      type: values?.typeValue === 'percent' ? 'PERCENT' : 'AMOUNT',
      value: amountValue,
    },
    status: 'ACTIVE',
    duration:
      occurrences > 0
        ? {
            type: 'REPEATING',
            occurrences,
          }
        : {
            type: 'FOREVER',
          },
    reference_id: values?.id,
    name: values?.name,
    description: 'Cupom keap',
    // redemption_limit: Number(values?.limitAplly),
  }
}

export const CreateSchemaPlansPagBank = (values) => {
  const expired = values?.typeExpired || values?.daysExpired || 0

  let intervalUnit
  let intervalLength

  if (expired >= 365) {
    intervalUnit = 'YEAR'
    intervalLength = expired / 365
  } else if (expired >= 30) {
    intervalUnit = 'MONTH'
    intervalLength = expired / 30
  } else {
    intervalUnit = 'DAY'
    intervalLength = expired
  }

  const trialDays = values?.trialDays || 0
  const setupFee = Number(values?.admission || '0')

  const amountValue = Math.round(values.value * 100)

  return {
    amount: {
      currency: 'BRL',
      value: amountValue,
    },
    interval: {
      unit: intervalUnit,
      length: Math.floor(intervalLength), // arredonda pra evitar quebrado
    },
    ...(trialDays > 0 && {
      trial: {
        enabled: trialDays > 0,
        hold_setup_fee: trialDays > 0,
        days: trialDays,
      },
    }),
    payment_method: ['CREDIT_CARD'],
    description: values?.desc || '',
    name: values.name,
    reference_id: values.id,
    ...(setupFee > 0 && { setup_fee: setupFee }),
  }
}

export const translatePlan = (value) => {
  switch (value) {
    case 'collab':
      return 'Colaborador'
    case 'coupon':
      return 'Cupom'
    case 'client':
      return 'Cliente'
    default:
      return value
  }
}
